/**
 * Tests that need the device in / able to enter default_on.
 * Start warning matches the original default_on empty-tank confirm.
 *
 * From TestingScript:
 * - default_on: enters default_on
 * - pulse_calibration: connectivity requires already default_on (with flowing water)
 * - master: final filter_replace flush waits for / requires default_on
 */
const DEFAULT_ON_REQUIRED_SCENARIOS = new Set([
  "default_on",
  "pulse_calibration",
  "master",
]);

const EMPTY_TANK_ALERT = {
  title: "Start test?",
  message: "Tank needs to be empty to start the default on test.",
};

const ALERT_TITLES = {
  default_on: "Start Default-On test?",
  pulse_calibration: "Start Pulse Calibration?",
  master: "Start Master test?",
};

export function getTestStartAlert(scenario) {
  if (!DEFAULT_ON_REQUIRED_SCENARIOS.has(scenario)) return null;
  return {
    title: ALERT_TITLES[scenario] || EMPTY_TANK_ALERT.title,
    message: EMPTY_TANK_ALERT.message,
  };
}
